/**
 * The Arcadia controlled status for risk.
 *
 * The values within this enum match the Arcadia ontology labels of type "RiskStatus".
 */
export enum RiskStatus {
  Closed = 'RiskClosed',
  Pending = 'RiskPending',
  Persistent = 'RiskPersistent',
  Suspected = 'RiskSuspected',
  Unconfirmed = 'RiskUnconfirmed',
}

export const riskStatusPrefix = 'Risk';
